import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Heading from '@marvelapp/marvel-ui/heading';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';

import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck.js';
import FadingBackground from 'marketing-website/components/commons/FadingBackground';

import Image from 'marketing-website/components/modules/Image';
import SmartVideo from 'marketing-website/components/modules/SmartVideo';

import heroStyles from '../style/general.module.css';
import generalStyles from './style/general.module.css';
import headlineStyles from './style/headline.module.css';
import backgroundStyles from './style/background.module.css';
import mediaStyles from './style/media.module.css';

const heroBackgrounds = Object.keys(backgroundStyles);

const cx = classNames.bind({
  ...backgroundStyles,
  ...generalStyles,
  ...headlineStyles,
  ...heroStyles,
  ...mediaStyles,
});

export default function HeroMedia({
  backgroundColor,
  color,
  headline,
  headlineMaxWidth,
  image,
  name,
  type,
  ctaBlock,
  tag,
}) {
  const heroClassName = cx('hero', 'heroMedia', { height: type !== 'none' });
  const mediaHolderClassName = cx('mediaHolder');
  const headlineClassName = cx('headline');
  return (
    <div className={heroClassName}>
      <div className={headlineClassName}>
        <PageWrap size="l" maxWidth={headlineMaxWidth}>
          <Heading tag={tag} size="xxxxl" color={color} weight="semibold">
            {headline}
          </Heading>
        </PageWrap>
        {ctaBlock}
      </div>

      <FadingBackground backgroundColor={backgroundStyles[backgroundColor]} />

      <div className={mediaHolderClassName}>
        <PageWrap size="l">
          {type === 'video' && <SmartVideo name={name} autoPlay loop />}
          {type === 'image' && <Image {...image} hasShadow={false} />}
        </PageWrap>
      </div>
    </div>
  );
}

const validTags = ['h1', 'h2'];

HeroMedia.propTypes = {
  backgroundColor: PropTypes.oneOf(heroBackgrounds),
  color: PropTypes.string,
  headline: propTypeEmptyString,
  headlineMaxWidth: PropTypes.number,
  image: PropTypes.object,
  name: PropTypes.string,
  type: PropTypes.oneOf(['image', 'video', 'none']).isRequired,
  ctaBlock: PropTypes.object,
  tag: PropTypes.oneOf(validTags),
};

HeroMedia.defaultProps = {
  backgroundColor: 'white',
  color: 'white',
  type: 'none',
  tag: 'h1',
};



// WEBPACK FOOTER //
// ./src/components/modules/Hero/HeroMedia/index.js